import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'helpers/no_conflict_lodash';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import { startUpdateRecord, handleUpdateRecord, updateEditingRecord } from '../store/actions/run_records';

export class RecordRow extends React.Component {
  static propTypes = {
    currentStep: PropTypes.string.isRequired,
    editingRecord: PropTypes.object.isRequired,
    editRow: PropTypes.bool.isRequired,
    headers: PropTypes.array.isRequired,
    record: PropTypes.shape({
      errorFields: PropTypes.array.isRequired,
      id: PropTypes.number.isRequired,
      index: PropTypes.number.isRequired,
      mappedFields: PropTypes.array.isRequired,
      headerToFields: PropTypes.object.isRequired,
      skip: PropTypes.bool.isRequired,
      target: PropTypes.string.isRequired
    }).isRequired,
    onStartUpdateRecord: PropTypes.func.isRequired,
    onUpdateEditingRecord: PropTypes.func.isRequired,
    onUpdateRecord: PropTypes.func.isRequired,
  };

  state = {
    editingField: null,
    record: this.props.record
  }

  inputRef = React.createRef();

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { editRow, record: { id } } = this.props;

    if (!editRow && prevProps.editingRecord.id === id && prevProps.editRow) {
      this.setState({
        record: {
          ...this.props.record
        }
      });
    }
  }

  handleClickOutside = (e) => {
    if (this.inputRef && this.inputRef.current &&
        !this.inputRef.current.contains(e.target)) {
      this.setState({ editingField: null });
    }
  }

  handleEditCell = (field) => {
    const { record, onStartUpdateRecord } = this.props;

    if (this.editableCell(field)) {
      onStartUpdateRecord(record, false);
      this.setState({ editingField: field });
    }
  }

  throttleRecordUpdate = _.throttle(this.props.onUpdateRecord, 1000);

  handleEditRecord = (field, value) => {
    const { editingRecord, editRow, onUpdateEditingRecord } = this.props;

    const newHeaderFields = { ...editingRecord.headerToFields };
    newHeaderFields[field] = value;
    editingRecord.headerToFields = { ...newHeaderFields };

    onUpdateEditingRecord(editingRecord);
    if (!editRow) {
      this.throttleRecordUpdate(false);
    }
  }

  editableCell = (field) => {
    const { currentStep, record: { mappedFields } } = this.props;
    return mappedFields.includes(field) && currentStep == "preview";
  }

  renderInput = (field) => {
    const { editingRecord } = this.props;

    return (
      <td className="table-cell p-0" key={`${editingRecord.id} + ${field}`}>
        <input
          className="h-100 w-100"
          name={`${field}-input`}
          ref={this.inputRef}
          type="text"
          value={editingRecord.headerToFields[field] || ""}
          onChange={e => (this.handleEditRecord(field, e.target.value))}
        />
      </td>
    );
  }

  renderCell(field) {
    const { record } = this.props;

    const editableCell = this.editableCell(field);

    const cellClass = classNames({
      "editable-table-cell": editableCell,
      "table-cell": !editableCell,
      "record-status": record.errorFields.includes(field)
    });

    return (
      <td
        className={cellClass}
        key={`${record.id} + ${field}`}
        onClick={() => this.handleEditCell(field)}
      >
        <div className="d-inline-flex w-100">
          <div className="w-100">{record.headerToFields[field]}</div>
          {editableCell &&
            <FontAwesomeIcon
              className="pull-right edit-icon ml-3"
              icon={faEdit}
              size="lg"
            />
          }
        </div>
      </td>
    );
  }

  renderHeaderCells() {
    const { headers, record, editingRecord, editRow } = this.props;
    const { editingField } = this.state;

    return headers.map((header) => {
      if ((editingField === header && record.id === editingRecord.id) ||
        (record.id === editingRecord.id && editRow)) {
        return this.renderInput(header);
      } else {
        return this.renderCell(header);
      }
    });
  }

  render() {
    const { currentStep, record } = this.props;

    return (
      <tr className={`${record.previewStatus}-row`} key={record.id}>
        {currentStep === "preview" && <td className="text-italic table-cell">{record.target}</td>}
        {this.renderHeaderCells()}
      </tr>
    );
  }
}

const mapStateToProps = state => ({
  currentStep: state.ui.currentStep,
  editRow: state.runRecords.editRow,
  editingRecord: state.runRecords.editingRecord,
  headers: state.runRecords.headers
});

const mapDispatchToProps = {
  onStartUpdateRecord: startUpdateRecord,
  onUpdateEditingRecord: updateEditingRecord,
  onUpdateRecord: handleUpdateRecord
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordRow);
